import { useQuery } from "react-query";

import {
  USER_DATA_SOURCES_QUERY_KEY,
  UserDataSourcePreferenceItem,
  fetchUserDataSources
} from "api/dataSource";

/**
 * The org's ordered HEADER-data-source preference (`Category.HeaderData`
 * server-side) — a separately-settable preference from `useSurveyDataSources`'s
 * `SurveyData` category (see MidstreamSources.ts). eva-map-svc keys the base
 * well tile's attribute session on this order (`attrPrefKey` /
 * `GetAndSetUserHeaderDataSourceOrder`), so this hook exists to let the base
 * layer react when it changes — see buildHeaderPreferenceToken.
 */
export function useHeaderDataSources(): UserDataSourcePreferenceItem[] {
  const { data } = useQuery(USER_DATA_SOURCES_QUERY_KEY, fetchUserDataSources, {
    select: (response) => {
      if (response.ok) {
        const category = response.value.find((c) => c.category === "HeaderData");
        return category?.dataSources ?? [];
      }
      return [];
    }
  });
  return data ?? [];
}
